import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const ListModalHTML: FC = () => {
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const style = `
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center {
      width: 80%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 2rem;
    }
    .modal_wrapper {
      width: 100%;
      padding: 2rem 1rem;

      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      border-radius: ${radius?.background}px;
      background-color: ${bgColor?.background};
    }

    .title {
      height: 3rem;
      display: flex;
      align-items: center;
    }
    .title_inner {
      width: 100%;
      height: auto;
      max-height: 3rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${fontFamily?.title};
    }

    .middle_wrapper {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .middle_text_wrapper {
      height: 4rem;
      display: flex;
      align-items: center;
      overflow: hidden;
    }
    .middle_text_wrapper .middle_number {
      max-width: 3rem;
      min-width: 3rem;
      max-height: 3rem;
      min-height: 3rem;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1.25rem;
      font-weight: 700;
    }
    .middle_text_wrapper .middle_text {
      height: 4rem;
      display: flex;
      align-items: center;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.multi_text]};
    }
    .middle_text_inner {
      height: auto;
      max-height: 4rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
    }
    .middle_text {
      text-align: ${textAlign?.multi_text};
      color: ${color?.multi_text};
      font-size: ${fontSize?.multi_text}rem;
      font-weight: ${fontWeight?.multi_text};
      font-family: ${fontFamily?.multi_text};
    }

    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${btnFontFamily?.button} !important;

      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

    .bottom_wrapper {
      height: 1.25rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.never_show_button};
      font-weight: ${btnFontWeight?.never_show_button};
      font-size: ${btnFontSize?.never_show_button}rem;
      font-family: ${btnFontFamily?.never_show_button};
      background-color:rgba(${btnBgColorR?.never_show_button},${
    btnBgColorG?.never_show_button
  }, ${btnBgColorB?.never_show_button}, ${btnBgColorA?.never_show_button});
    }
    .bottom_wrapper .style02 {
      width: 100%;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.sub_button};
      font-weight: ${btnFontWeight?.sub_button};
      font-size: ${btnFontSize?.sub_button}rem;
      font-family: ${btnFontFamily?.sub_button};
      background-color:rgba(${btnBgColorR?.sub_button},${
    btnBgColorG?.sub_button
  }, ${btnBgColorB?.sub_button}, ${btnBgColorA?.sub_button});
    }

    @media screen and (max-width: 301px) {
      .modal_wrapper {
        gap: 0.5rem;
      }
      .middle_text_wrapper .middle_number {
        max-width: 2rem;
        min-width: 2rem;
        max-height: 2rem;
        min-height: 2rem;
      }

      .btn_wrapper {
        margin-top: 0.5rem;
      }
    }

		@media screen and (min-width: 608px) and (max-width: 1024px) {
      .center {
        width: 50%;
      }
      .modal_wrapper {
        padding: 2rem;
      }

      .title {
        height: 4rem;
      }
      .title_inner {
        max-height: 4rem;
        font-size: ${fontSize?.title + 0.375}rem;
      }

      .middle_text_wrapper .middle_text {
        height: 5rem;
      }
      .middle_text_inner {
        max-height: 5rem;
        font-size: ${fontSize?.multi_text + 0.05}rem;
      }

      .btn_wrapper {
        margin-top: 1rem;
      }
    }
  `;

  const html = `
    <div class="root" id="test">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="center">
        <div class="modal_wrapper">
          <div class="title">
            <div class="title_inner">${changeEnterHTML(text?.title)}</div>
          </div>
          <div class="middle_wrapper">${text?.multi_text
            ?.map(
              (text: string, idx: number) => `<div class="middle_text_wrapper">
            <p class="middle_number">${idx + 1}</p>
            <p class="middle_text">${changeEnterHTML(text)}</p>
          </div>`
            )
            .join('')}
          </div>
          <div class="btn_wrapper">
            <button onclick="appboyBridge.logClick('0');appboyBridge.closeMessage();">
              ${btnText?.button}
            </button>
          </div>
        </div>
        <div class="bottom_wrapper">
          <span class="style01">
            <input
              class="bottom_input"
              type="checkbox"
              value="never-show"
              name="never-show"
            />
            <span>${btnText?.never_show_button}</span>
          </span>
          <span class="style02" onclick="appboyBridge.logClick('1');appboyBridge.closeMessage();">${
            btnText?.sub_button
          }</span>
        </div>
      </div>
    </div>
  `;

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    $('.style01').click(function() {
      let checked = $('.bottom_input').is(':checked');
      $('input.bottom_input').prop('checked', !checked);
    });
    $('.style02').click(function() {
      let checked = $('.bottom_input').is(':checked');
      if (checked) {
        appboyBridge.getUser().setCustomUserAttribute(${btnText?.never_show_button}, new Date());
        appboyBridge.logCustomEvent(${btnText?.never_show_button});
      }
      appboyBridge.logClick('1');
      appboyBridge.closeMessage();
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default ListModalHTML;
